import { defineComponent as _defineComponent } from 'vue'
import pdf from "vue-pdf";
import BaseDialog from "@/components/base-dialog.vue";
import {
  useShowErrorMessage,
  useShowSuccessMessage,
} from "@/composables/use-notifications";
import { MessageBox } from "element-ui";
import { computed, ref } from "vue";
import ScaleOut from "@/components/scale-out-component.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'preview-file-upload-answer-sheet-dialog',
  props: {
    isVisible: { type: Boolean },
    fileUrl: null
  },
  emits: {
  "on-close": () => true,
  "on-submit-intent": () => true,
},
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  fileUrl: string;
}





const activePage = ref(1);
const isLoading = ref(true);
const progress = ref(0);
const totalPages = ref("N/A");

const downloadProgress = computed(() => {
  return Math.round(progress.value * 100);
});

const onPDfError = () => {
  useShowErrorMessage(
    "loading Failed",
    "Unable to load the selected Document, please try again"
  );
};

const onLoaded = () => {
  isLoading.value = false;
};
const onProgress = (value: number) => {
  if (!value) return;
  progress.value = value;
};

const onNextPage = () => {
  if (activePage.value == +totalPages.value) return;
  ++activePage.value;
  window.scrollTo(0, 0);
};

const onPreviousPage = () => {
  if (activePage.value == 1) return;
  --activePage.value;
  window.scrollTo(0, 0);
};

const onPageNumberObtained = (pageNumber: number) => {
  totalPages.value = `${pageNumber}`;
};

const onClose = () => {
  emit("on-close");
};

const onSubmitOnlineAnswerSheetIntent = () => {
  return MessageBox.alert(
    "You are about to submit your answer sheet. Are you sure you want to proceed?",
    {
      title: "Submit Answer Sheet",
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      distinguishCancelAndClose: true,
      closeOnClickModal: true,
      closeOnPressEscape: true,
      callback: (action) => {
        if (action == "confirm") {
          emit("on-submit-intent");
        }
      },
    }
  );
};

const isWordDocument = computed((): boolean => {
  const wordDocumentExtensions = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
  const fileExtension = props.fileUrl.split(".").pop()?.toLowerCase() || "";

  return wordDocumentExtensions.includes(fileExtension);
});

const isPdfDocument = computed((): boolean => {
  const pdfDocumentExtensions = ["pdf"];
  const fileExtension = props.fileUrl.split(".").pop()?.toLowerCase() || "";

  return pdfDocumentExtensions.includes(fileExtension);
});

// const isUnsupportedDocument = computed((): boolean => {
//   return !isWordDocument.value && !isPdfDocument.value;
// });

const onDownloadPreviewFile = () => {
  useShowSuccessMessage(
    "Download Started",
    "Your file is being downloaded. Please wait..."
  );

  const link = document.createElement("a");
  link.href = decodeURIComponent(props.fileUrl);
  link.download = "File preview";
  link.click();
};

return { __sfc: true,props, emit, activePage, isLoading, progress, totalPages, downloadProgress, onPDfError, onLoaded, onProgress, onNextPage, onPreviousPage, onPageNumberObtained, onClose, onSubmitOnlineAnswerSheetIntent, isWordDocument, isPdfDocument, onDownloadPreviewFile, pdf, BaseDialog, ScaleOut }
}

})